export default [
    {
        path: '/find-provider',
        name: 'public.find-provider',
        view: 'public/FindProvider',
    },

    {
        path: `/find-provider/results`,
        name: 'public.find-provider.results',
        view: 'public/FindProviderResults',
        default: { query: { limit: 6 } },
    },
    {
        path: '/support/report-bug',
        name: 'public.support.report-bug',
        view: 'public/Support',
    },
    {
        path: '/referral-leakage-audit',
        name: 'public.referral-leakage-audit',
        view: 'public/ReferralLeakageAudit',
        middlewares: [],
    },
]
